import { render } from "./DashPesquisador.vue?vue&type=template&id=3cfb09e5"
import script from "./DashPesquisador.vue?vue&type=script&lang=js"
export * from "./DashPesquisador.vue?vue&type=script&lang=js"
script.render = render

export default script